import React, { useCallback, useMemo } from 'react';
import { createStyles, withStyles, Grid, Typography, Button, Box } from '@material-ui/core';
import { I18n } from 'src/translations/i18n';
import dayjs from 'dayjs';
import green from '@material-ui/core/colors/green';
import TextInput from '../Inputs/TextInput';
const styles = (theme) => createStyles({
    text: {
        color: theme.palette.text.color
    },
    actionButton: {
        backgroundColor: theme.palette.sideBar.itemActive.background,
        color: theme.palette.sideBar.itemActive.color,
        fontWeight: 500,
        '&:hover': {
            backgroundColor: theme.palette.sideBar.itemActive.background
        }
    }
});
const MAX_COMMENT_LENGTH = 200;
function EndShiftForm({ classes, activeEvent, comment, onCommentChange, onEndShift, disableShiftButton, enableComment }) {
    const commentLength = comment.length;
    const activeShiftContainerStyle = useMemo(() => ({
        backgroundColor: activeEvent.Event.Job.JobProfile?.Color?.Start || green[500],
        color: activeEvent.Event.Job.JobProfile?.Color?.Font || 'white'
    }), [activeEvent]);
    const commentInputLabelWithCounter = useMemo(() => {
        const charsLeft = MAX_COMMENT_LENGTH - commentLength;
        return `${I18n.t('UpdateComment')} (${charsLeft})`;
    }, [commentLength]);
    const commentChangeHandler = useCallback((newContent) => {
        if (newContent.length > MAX_COMMENT_LENGTH)
            return;
        onCommentChange(newContent);
    }, [onCommentChange]);
    const startTime = useMemo(() => dayjs(activeEvent.Event.StartTime).format('HH:mm'), [activeEvent]);
    const timeAgo = useMemo(() => dayjs(activeEvent.Event.StartTime).fromNow(), [activeEvent]);
    return (React.createElement(Grid, { container: true, spacing: 1, direction: "column" },
        React.createElement(Grid, { item: true },
            React.createElement(Typography, { variant: "body1", className: classes.text, gutterBottom: true }, I18n.t('RegisteredJob'))),
        React.createElement(Grid, { item: true },
            React.createElement(Box, { display: "flex", flexDirection: "column", style: activeShiftContainerStyle, padding: 0.8, borderRadius: 4 },
                React.createElement(Box, { display: "flex", justifyContent: "center" }, activeEvent.Event.Job.Name || 'N/A'),
                React.createElement(Box, { display: "flex", justifyContent: "space-between" },
                    React.createElement("span", null, `${I18n.t('Started')} ${startTime}`),
                    React.createElement("span", null, timeAgo)))),
        React.createElement(Grid, { item: true },
            React.createElement(Box, { display: "flex", flexDirection: "column", py: 2 },
                React.createElement(Button, { className: classes.actionButton, fullWidth: true, size: "large", variant: "contained", onClick: onEndShift, disabled: disableShiftButton }, I18n.t('FinishJob')))),
        enableComment && (React.createElement(Grid, { item: true },
            React.createElement(TextInput
            // @ts-ignore
            , { 
                // @ts-ignore
                label: commentInputLabelWithCounter, placeholder: I18n.t('Comment'), type: "textarea", value: comment, onChange: commentChangeHandler, rows: 6, style: { resize: 'none' } })))));
}
export default withStyles(styles)(EndShiftForm);
